import React from 'react';
import { SectionDivider } from './ui/SectionDivider';
export function TestimonialSection() {
  return <section className="bg-[#F5EDE0] py-16 md:py-24 px-4 sm:px-6 lg:px-8" data-id="element-213">
      <div className="max-w-3xl mx-auto text-center" data-id="element-214">
        <h2 className="font-playfair text-3xl md:text-4xl font-bold text-[#3D2E1F] mb-8" data-id="element-215">
          Qué cambia en 7 días:
        </h2>

        <div className="bg-white p-8 md:p-12 rounded-2xl shadow-lg border border-[#B8A068] relative" data-id="element-216">
          <span className="absolute -top-6 left-1/2 -translate-x-1/2 text-6xl text-[#B8A068] opacity-30 font-serif" data-id="element-217">
            "
          </span>
          <p className="text-[#3D2E1F] text-lg md:text-xl italic relative z-10" data-id="element-218">
            En la primera semana, notarás que el tiempo que tardas en
            "desentumecerte" se reduce a la mitad. Tus dedos recuperarán su
            capacidad de cierre y esa primera caminata hacia la cocina dejará de
            ser una tortura para convertirse en un paseo fluido.
          </p>
        </div>

        <SectionDivider data-id="element-219" />
      </div>
    </section>;
}